import { Button, Form, FormProps, Input } from 'antd'
import { EditPlaylistDTO } from '../../utils/redux/playlistsSlice'
import { PlaylistPosterFormItem } from '../PlaylistForm/PlaylistPosterFormItem'
import PlaylistSongsFormItem from '../PlaylistForm/PlaylistSongsFormItem'
import { UploadedFolderDestination } from './NewFolder'
import { useEffect, useState } from 'react'
import { Song } from '../../utils/redux/songsSlice'

interface Props extends FormProps<EditPlaylistDTO> {
  isLoading: boolean
  uploadedDestination: UploadedFolderDestination
}
export default function OrderPlaylistForm({
  isLoading,
  uploadedDestination,
  ...formProps
}: Props) {
  const [songs, setSongs] = useState<Song[]>([])
  const [playlistForm] = Form.useForm<EditPlaylistDTO>()
  
  useEffect(() => {
    playlistForm.setFieldsValue({
      songs: songs.map((song) => song._id),
    })
  }, [songs])

  return (
    <Form layout="vertical" form={playlistForm} {...formProps}>
      <Form.Item name="image" rules={[{ required: true }]}>
        <PlaylistPosterFormItem
          uploadedDestination={uploadedDestination}
        />
      </Form.Item>
      <Form.Item
        name="title"
        rules={[{ required: true, message: 'Please input playlist title!' }]}
      >
        <Input placeholder="Title" />
      </Form.Item>
      <Form.Item
        name="songs"
        rules={[{ required: true, message: 'Playlist can not be empty!' }]}
      >
        <PlaylistSongsFormItem 
          onAdd={(song) => {
            setSongs((prev) => [...prev, song])
          }}
          onDelete={(song) => {
            setSongs((prev) => prev.filter((s) => s._id !== song._id))
          }}
          setPlaylistSongs={setSongs}
          playlistSongs={songs}
        />
      </Form.Item>
      <Form.Item>
        <Button block type="primary" htmlType="submit" loading={isLoading}>
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}
